<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-用户中心
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['curItem'],
    methods: {

    }
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/page/tabbar/diy/params/AgentInfo.vue